export enum FamilyСomposition {
    full,
    notFull,
    maternal,
    mixed,
    orphans
}

export const compositions: any[] = [
  { id: 0, name: 'Полная'},
  { id: 1, name: 'Неполная'},
  { id: 2, name: 'Материнская семья'},
  { id: 3, name: 'Смешанная семья или семья повторного брака'},
  { id: 4, name: 'Дети-сироты'}
];